import { IS_FRAME_SERVICE } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/frameService';

const VARIANTS = {
    B: 'B',
    C: 'C',
};

// Neovisno koju variantu frontend primi uvijek vraćamo variantu "A" ako se radi o frame service-u.
export const isVariantB = (variant) => !IS_FRAME_SERVICE && variant === VARIANTS.B;

export const isVariantC = (variant) => !IS_FRAME_SERVICE && variant === VARIANTS.C;
